import React from 'react'
import { isEmpty } from '../../utils/lang'

export default function JsonLd({ data }) {
  if (isEmpty(data)) return <></>
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />
}
